<div class="no__data flex-column-centered br-8" [style.height]="boxHeight">
  <img [src]="iconPath" alt="icon">
  <p *ngIf="translateKey" class="no__data-text fw-400 fz-16 lh-24">{{ translateKey | translate }}</p>
</div>